import apiClient from './apiClient';

export const authAPI = {
  login: (username, password) => 
    apiClient.post('/auth/token/', { username, password }),
  
  logout: () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
  },
  
  getCurrentUser: () => apiClient.get('/auth/users/me/'),
};